/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerkefniRouteImport } from './routes/verkefni'
import { Route as UmsoknRouteImport } from './routes/umsokn'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VerkefniNumberRouteImport } from './routes/verkefni_.$number'
import { Route as UmsoknStadfestingRouteImport } from './routes/umsokn.stadfesting'
import { Route as SettingsHiddenRouteImport } from './routes/settings_.hidden'
import { Route as CompaniesIdRouteImport } from './routes/companies.$id'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminUmsoknirRouteImport } from './routes/admin.umsoknir'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminOthekktEfniRouteImport } from './routes/admin.othekkt-efni'
import { Route as AdminNullLosanirRouteImport } from './routes/admin.null-losanir'
import { Route as AdminMailpitRouteImport } from './routes/admin.mailpit'
import { Route as AdminCompaniesRouteImport } from './routes/admin.companies'
import { Route as AdminActivityRouteImport } from './routes/admin.activity'

const VerkefniRoute = VerkefniRouteImport.update({
  id: '/verkefni',
  path: '/verkefni',
  getParentRoute: () => rootRouteImport,
} as any)
const UmsoknRoute = UmsoknRouteImport.update({
  id: '/umsokn',
  path: '/umsokn',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerkefniNumberRoute = VerkefniNumberRouteImport.update({
  id: '/verkefni_/$number',
  path: '/verkefni/$number',
  getParentRoute: () => rootRouteImport,
} as any)
const UmsoknStadfestingRoute = UmsoknStadfestingRouteImport.update({
  id: '/stadfesting',
  path: '/stadfesting',
  getParentRoute: () => UmsoknRoute,
} as any)
const SettingsHiddenRoute = SettingsHiddenRouteImport.update({
  id: '/settings_/hidden',
  path: '/settings/hidden',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesIdRoute = CompaniesIdRouteImport.update({
  id: '/companies/$id',
  path: '/companies/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUmsoknirRoute = AdminUmsoknirRouteImport.update({
  id: '/admin/umsoknir',
  path: '/admin/umsoknir',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOthekktEfniRoute = AdminOthekktEfniRouteImport.update({
  id: '/admin/othekkt-efni',
  path: '/admin/othekkt-efni',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNullLosanirRoute = AdminNullLosanirRouteImport.update({
  id: '/admin/null-losanir',
  path: '/admin/null-losanir',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMailpitRoute = AdminMailpitRouteImport.update({
  id: '/admin/mailpit',
  path: '/admin/mailpit',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCompaniesRoute = AdminCompaniesRouteImport.update({
  id: '/admin/companies',
  path: '/admin/companies',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminActivityRoute = AdminActivityRouteImport.update({
  id: '/admin/activity',
  path: '/admin/activity',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/customers': typeof CustomersRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/umsokn': typeof UmsoknRouteWithChildren
  '/verkefni': typeof VerkefniRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/mailpit': typeof AdminMailpitRoute
  '/admin/null-losanir': typeof AdminNullLosanirRoute
  '/admin/othekkt-efni': typeof AdminOthekktEfniRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/umsoknir': typeof AdminUmsoknirRoute
  '/admin/users': typeof AdminUsersRoute
  '/companies/$id': typeof CompaniesIdRoute
  '/settings/hidden': typeof SettingsHiddenRoute
  '/umsokn/stadfesting': typeof UmsoknStadfestingRoute
  '/verkefni/$number': typeof VerkefniNumberRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/customers': typeof CustomersRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/umsokn': typeof UmsoknRouteWithChildren
  '/verkefni': typeof VerkefniRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/mailpit': typeof AdminMailpitRoute
  '/admin/null-losanir': typeof AdminNullLosanirRoute
  '/admin/othekkt-efni': typeof AdminOthekktEfniRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/umsoknir': typeof AdminUmsoknirRoute
  '/admin/users': typeof AdminUsersRoute
  '/companies/$id': typeof CompaniesIdRoute
  '/settings/hidden': typeof SettingsHiddenRoute
  '/umsokn/stadfesting': typeof UmsoknStadfestingRoute
  '/verkefni/$number': typeof VerkefniNumberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/customers': typeof CustomersRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/umsokn': typeof UmsoknRouteWithChildren
  '/verkefni': typeof VerkefniRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/mailpit': typeof AdminMailpitRoute
  '/admin/null-losanir': typeof AdminNullLosanirRoute
  '/admin/othekkt-efni': typeof AdminOthekktEfniRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/umsoknir': typeof AdminUmsoknirRoute
  '/admin/users': typeof AdminUsersRoute
  '/companies/$id': typeof CompaniesIdRoute
  '/settings_/hidden': typeof SettingsHiddenRoute
  '/umsokn/stadfesting': typeof UmsoknStadfestingRoute
  '/verkefni_/$number': typeof VerkefniNumberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/customers'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/settings'
    | '/umsokn'
    | '/verkefni'
    | '/admin/activity'
    | '/admin/companies'
    | '/admin/mailpit'
    | '/admin/null-losanir'
    | '/admin/othekkt-efni'
    | '/admin/settings'
    | '/admin/umsoknir'
    | '/admin/users'
    | '/companies/$id'
    | '/settings/hidden'
    | '/umsokn/stadfesting'
    | '/verkefni/$number'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/customers'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/settings'
    | '/umsokn'
    | '/verkefni'
    | '/admin/activity'
    | '/admin/companies'
    | '/admin/mailpit'
    | '/admin/null-losanir'
    | '/admin/othekkt-efni'
    | '/admin/settings'
    | '/admin/umsoknir'
    | '/admin/users'
    | '/companies/$id'
    | '/settings/hidden'
    | '/umsokn/stadfesting'
    | '/verkefni/$number'
  id:
    | '__root__'
    | '/'
    | '/customers'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/settings'
    | '/umsokn'
    | '/verkefni'
    | '/admin/activity'
    | '/admin/companies'
    | '/admin/mailpit'
    | '/admin/null-losanir'
    | '/admin/othekkt-efni'
    | '/admin/settings'
    | '/admin/umsoknir'
    | '/admin/users'
    | '/companies/$id'
    | '/settings_/hidden'
    | '/umsokn/stadfesting'
    | '/verkefni_/$number'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CustomersRoute: typeof CustomersRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SettingsRoute: typeof SettingsRoute
  UmsoknRoute: typeof UmsoknRouteWithChildren
  VerkefniRoute: typeof VerkefniRoute
  AdminActivityRoute: typeof AdminActivityRoute
  AdminCompaniesRoute: typeof AdminCompaniesRoute
  AdminMailpitRoute: typeof AdminMailpitRoute
  AdminNullLosanirRoute: typeof AdminNullLosanirRoute
  AdminOthekktEfniRoute: typeof AdminOthekktEfniRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminUmsoknirRoute: typeof AdminUmsoknirRoute
  AdminUsersRoute: typeof AdminUsersRoute
  CompaniesIdRoute: typeof CompaniesIdRoute
  SettingsHiddenRoute: typeof SettingsHiddenRoute
  VerkefniNumberRoute: typeof VerkefniNumberRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verkefni': {
      id: '/verkefni'
      path: '/verkefni'
      fullPath: '/verkefni'
      preLoaderRoute: typeof VerkefniRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/umsokn': {
      id: '/umsokn'
      path: '/umsokn'
      fullPath: '/umsokn'
      preLoaderRoute: typeof UmsoknRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkefni_/$number': {
      id: '/verkefni_/$number'
      path: '/verkefni/$number'
      fullPath: '/verkefni/$number'
      preLoaderRoute: typeof VerkefniNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/umsokn/stadfesting': {
      id: '/umsokn/stadfesting'
      path: '/stadfesting'
      fullPath: '/umsokn/stadfesting'
      preLoaderRoute: typeof UmsoknStadfestingRouteImport
      parentRoute: typeof UmsoknRoute
    }
    '/settings_/hidden': {
      id: '/settings_/hidden'
      path: '/settings/hidden'
      fullPath: '/settings/hidden'
      preLoaderRoute: typeof SettingsHiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/$id': {
      id: '/companies/$id'
      path: '/companies/$id'
      fullPath: '/companies/$id'
      preLoaderRoute: typeof CompaniesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/umsoknir': {
      id: '/admin/umsoknir'
      path: '/admin/umsoknir'
      fullPath: '/admin/umsoknir'
      preLoaderRoute: typeof AdminUmsoknirRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/othekkt-efni': {
      id: '/admin/othekkt-efni'
      path: '/admin/othekkt-efni'
      fullPath: '/admin/othekkt-efni'
      preLoaderRoute: typeof AdminOthekktEfniRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/null-losanir': {
      id: '/admin/null-losanir'
      path: '/admin/null-losanir'
      fullPath: '/admin/null-losanir'
      preLoaderRoute: typeof AdminNullLosanirRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/mailpit': {
      id: '/admin/mailpit'
      path: '/admin/mailpit'
      fullPath: '/admin/mailpit'
      preLoaderRoute: typeof AdminMailpitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/companies': {
      id: '/admin/companies'
      path: '/admin/companies'
      fullPath: '/admin/companies'
      preLoaderRoute: typeof AdminCompaniesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/activity': {
      id: '/admin/activity'
      path: '/admin/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AdminActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface UmsoknRouteChildren {
  UmsoknStadfestingRoute: typeof UmsoknStadfestingRoute
}

const UmsoknRouteChildren: UmsoknRouteChildren = {
  UmsoknStadfestingRoute: UmsoknStadfestingRoute,
}

const UmsoknRouteWithChildren =
  UmsoknRoute._addFileChildren(UmsoknRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CustomersRoute: CustomersRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SettingsRoute: SettingsRoute,
  UmsoknRoute: UmsoknRouteWithChildren,
  VerkefniRoute: VerkefniRoute,
  AdminActivityRoute: AdminActivityRoute,
  AdminCompaniesRoute: AdminCompaniesRoute,
  AdminMailpitRoute: AdminMailpitRoute,
  AdminNullLosanirRoute: AdminNullLosanirRoute,
  AdminOthekktEfniRoute: AdminOthekktEfniRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminUmsoknirRoute: AdminUmsoknirRoute,
  AdminUsersRoute: AdminUsersRoute,
  CompaniesIdRoute: CompaniesIdRoute,
  SettingsHiddenRoute: SettingsHiddenRoute,
  VerkefniNumberRoute: VerkefniNumberRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
